"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _warning = _interopRequireDefault(require("warning"));

var _yup = require("yup");

var _generateUtils = require("./generateUtils");

var _parseUtils = require("./parseUtils");

var _isEmptyObject = _interopRequireDefault(require("./isEmptyObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Location =
/*#__PURE__*/
function () {
  function Location(path) {
    var pathParamDefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var queryStringParamDefs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Location);

    this._path = path; //todo: warn about collisions between route params and qs params

    this._pathParamDefs = pathParamDefs || {};
    this._queryStringParamDefs = queryStringParamDefs || {};

    var paramDefs = _objectSpread({}, queryStringParamDefs, pathParamDefs);

    this._paramSchema = !(0, _isEmptyObject.default)(paramDefs) ? (0, _yup.object)().shape(paramDefs) : null;
  }

  _createClass(Location, [{
    key: "toUrl",
    value: function toUrl(params) {
      if (!this._paramSchema) {
        return this.path;
      }

      if (!(0, _generateUtils.validateParams)(this._paramSchema, params, true)) {
        //params don't satisfy schema
        return null;
      }

      var path = (0, _generateUtils.generatePath)(this.path, params);
      var queryString = (0, _generateUtils.generateQueryString)(this._queryStringParamDefs, params);
      return queryString ? "".concat(path, "?").concat(queryString) : path;
    }
  }, {
    key: "parseLocationParams",
    value: function parseLocationParams() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window && window.location;
      (0, _warning.default)(location, 'location must be explicitly provided when window object is not available.');
      (0, _warning.default)(location.pathname != undefined && location.search != undefined, 'location object must include pathname and search properties.');
      (0, _warning.default)(location.pathname, 'location.pathname is required.');

      try {
        if (!this._paramSchema) {
          return {};
        }

        var rawParams = _objectSpread({}, (0, _parseUtils.parsePath)(location.pathname, this.path), (0, _parseUtils.parseQueryString)(location.search));

        return this._paramSchema.validateSync(rawParams);
      } catch (err) {
        var name = err.name,
            errors = err.errors;

        if (name === 'ValidationError') {
          (0, _warning.default)(false, "Location.parseLocationParams: ".concat(errors[0]));
        } else {
          throw err;
        }

        return null;
      }
    }
  }, {
    key: "isValidParams",
    value: function isValidParams(params) {
      return (0, _generateUtils.validateParams)(this._paramSchema, params, false);
    }
  }, {
    key: "path",
    get: function get() {
      return this._path;
    }
  }]);

  return Location;
}();

exports.default = Location;